import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import DiscreteTabs from 'components/DesignSystem/Tabs/DiscreteTabs';
import TrackingForecastSubTabs from 'components/Meteorology/Fields/TrackingForecast/Mobile/SubTabs';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/weatherLayoutReducer';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function TrackingForecast() {
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('trackingforecast'));
  }, []);

  return (
    <div>
      {isMobile ? (
        <TrackingForecastSubTabs />
      ) : (
        <DiscreteTabs
          type="underline"
          activeKey="./"
        >
          <DiscreteTabs.Tab path="/meteorology/fields/trackingforecast/" title="Cadastro" />
          <DiscreteTabs.Tab path="/meteorology/fields/trackingforecast/detailedview" title="Visão Detalhada" />
        </DiscreteTabs>
      )}
      <div>
        <Outlet />
      </div>
    </div>
  );
}
